import { isObject } from 'util';
import { WidgetContentModel } from './widget-content.model';
import { IWidgetSettingsModel } from '@fi-shared/widget/widget-settings.model';
import { isDefined } from '@fi-shared/utils/is-defined';
import { FiDateFormatOptions } from '@fi-shared/utils/format-date';
import { WidgetPlaceHolderControlModel } from '@fi-shared/widget/widget-place-holder-control.model';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';
import { IContentLanguage } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';

export class WidgetModel {
    Id = 0;
    IsEnabled = false;
    WidgetType = 0;
    Description = '';

    CreatedByUserName: any;
    CreatedOn: any;
    CreatedOnDate: string;
    CreatedByUserId = 0;

    ChangedOn = new Date();
    ChangedOnDate = '';
    ChangedByUserId = 0;
    ChangedByUserName: any;
    //ChangedOn = '';
    Settings: IWidgetSettingsModel = {};
    WidgetModuleContentCollection: WidgetContentModel[] = [];
    TextId: string;

    constructor(contentLanguages: IContentLanguage[], fiFormatDateService: FiFormatDateService, initializeItem?) {
        this.ChangedOnDate = fiFormatDateService.formatDate(this.ChangedOn, FiDateFormatOptions);

        if (initializeItem) {
            this.Initialize(contentLanguages, initializeItem, fiFormatDateService);
        }
    }

    Initialize(contentLanguages: IContentLanguage[], widget, fiFormatDateService: FiFormatDateService) {
        this.Id = widget.Id;
        this.IsEnabled = widget.IsEnabled;
        this.WidgetType = widget.WidgetType;
        this.Description = widget.Description;
        this.CreatedByUserId = widget.CreatedByUserId;
        this.CreatedByUserName = widget.CreatedByUserName;
        this.CreatedOn = widget.CreatedOn;
        this.CreatedOnDate = fiFormatDateService.formatDate(this.CreatedOn, FiDateFormatOptions);
        this.ChangedByUserId = widget.ChangedByUserId;
        this.ChangedByUserName = widget.ChangedByUserName;
        this.IsEnabled = widget.IsEnabled;

        if (widget.Settings) {
            try {
                this.Settings = isObject(widget.Settings) ? widget.Settings : JSON.parse(widget.Settings);
            } catch (e) {
                this.Settings = {};
            }
        }
        this.Settings.DisplayContainer = true;
        var _self = this;

        if (widget.WidgetModuleContentCollection) {
            widget.WidgetModuleContentCollection.forEach(function (widgetContent) {
                _self.WidgetModuleContentCollection.push(new WidgetContentModel(contentLanguages, widgetContent));
            });
        }
    }

    onControlInitialized(control: WidgetPlaceHolderControlModel) {
        if (!isDefined(control.Settings.DisplayContainer)) {
            control.Settings.DisplayContainer = true;
        }
        if (!isDefined(control.Settings.DisplayHeader)) {
            control.Settings.DisplayHeader = true;
        }
    }
}
